<template>
    <div v-if="user">
        <div class="row">
            <div class="col-md-6 mb-4" v-if="user">
                <customer-purchases :user="user"></customer-purchases>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as CONST from '@/const';
import { Options, Vue } from 'vue-class-component';
import { PurchaseClient } from '@/services/Services';
import { LocalizationServices } from '@/services/LocalizationServices';
import { ModalServices } from '@/services/ModalServices';
import { Prop } from 'vue-property-decorator';
import qualification from '@/components/user/components/qualification.vue';
import customerPurchases from './customerPurchases.vue';

@Options({
    components: {
        qualification,
        customerPurchases
    }
})
export default class customerData extends Vue {
 
    @Prop() user: OM.Lead;

    purchases: OM.Purchase[] = [];
    surveyAnswers: OM.SurveyAnswers[] = [];

    created(){
        this.init();
    }

    init(){
        PurchaseClient.getByCliente(this.user.identifier, true).then(x => this.purchases = x);
    }

}

</script>
